import buildUrl from 'build-url';

export default class Urls {
  static relativeUrl(url) {
    return buildUrl(BASE_URL, {
      path: url
    });
  }
}
